import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const GlobeSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default GlobeSVG;
